// prettier-ignore
const navs = [
  { name: "labels.notifications", url: "/notifications/", icon: "fa-message", role: "admin" },
]

export default navs;
